
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/rincian-observasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/rincian-observasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/rincian-observasi"])
      });
    }
  